// import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import AnimateHeight from 'react-animate-height'

import { formatMoney, isBlank } from 'utils'

import ProductsFilterList from 'components/ProductsFilterList'
import ProductsFilterRange from 'components/ProductsFilterRange'
import Text from 'components/Text'

import { Caret, CaretIcon, Label, Root } from './ProductsFilter.style'
import CaretSvg from './svg/caret.svg'

const humanizedFilterKeys = {
  model: 'Model',
  season: 'Season',
  color: 'Color',
  size: 'Shop by Size',
  price: 'Price',
  category: 'Category',
  artisan: 'Artisan',
}

const filterComponents = {
  model: ProductsFilterList,
  season: ProductsFilterList,
  color: ProductsFilterList,
  size: ProductsFilterList,
  price: ProductsFilterRange,
  category: ProductsFilterList,
  artisan: ProductsFilterList,
}

const filterComponentProps = {
  size: { columns: 3 },
  price: { formatter: (val) => formatMoney(val, { fractional: true }) },
}

const ProductsFilter = ({ name, values = [], initialOpen = false, fixedOpen = false }) => {
  const initialIsOpen = fixedOpen || initialOpen

  const [isOpen, setIsOpen] = useState(initialIsOpen)
  const [height, setHeight] = useState(initialIsOpen ? 'auto' : 0)

  const title = humanizedFilterKeys[name]

  const toggleOpen = () => {
    if (fixedOpen) return

    setIsOpen(!isOpen)
  }

  useEffect(() => {
    isOpen ? setHeight('auto') : setHeight(0)
  }, [isOpen])

  const Filter = filterComponents?.[name]
  const filterProps = filterComponentProps?.[name]

  if (!Filter || isBlank(values)) return null

  return (
    <Root>
      <Label onClick={toggleOpen}>
        <Text weight="bold">{title}</Text>
        {!fixedOpen && (
          <Caret $isOpen={isOpen}>
            <CaretIcon $isOpen={isOpen}>
              <CaretSvg width={12} height={7} />
            </CaretIcon>
          </Caret>
        )}
      </Label>
      <AnimateHeight duration={300} height={height}>
        <Filter name={name} values={values} {...filterProps} />
      </AnimateHeight>
    </Root>
  )
}

ProductsFilter.propTypes = {}

ProductsFilter.defaultProps = {}

export default ProductsFilter
